import { DirectiveOptions,  DirectiveFunction} from 'vue/types/umd';
import debounce from "lodash/debounce";

export const resize: {[key: string]: DirectiveFunction | DirectiveOptions}  = {
    bind: function (el, binding) {
        if (window.ResizeObserver) {
            let resizeObserver;
            if(binding.arg){
                resizeObserver = new ResizeObserver(debounce((/* elements */) => binding.value(), parseInt(binding.arg)))
            } else {
                resizeObserver = new ResizeObserver((/* elements */) => binding.value())
            }
            resizeObserver.observe(el);
            //eslint-disable-next-line  @typescript-eslint/no-explicit-any
            (el as any).abacoResizeObserver = resizeObserver;
        } else {
            let elHeight = el.clientHeight;
            let elWidth = el.clientWidth;
            const timerId = window.setInterval(() => {
                if (el.clientHeight !== elHeight || el.clientWidth !== elWidth) {
                    elHeight = el.clientHeight;
                    elWidth = el.clientWidth;
                    binding.value()
                }
            }, binding.arg ? parseInt(binding.arg) : 500);
            el.dataset.timerId = timerId.toString();
        }
    },
    unbind: function (el) {
        if (el.dataset.timerId) {
            clearInterval(parseInt(el.dataset.timerId))
        }
        //eslint-disable-next-line  @typescript-eslint/no-explicit-any
        if ((el as any).abacoResizeObserver) {
            //eslint-disable-next-line  @typescript-eslint/no-explicit-any
            ((el as any).abacoResizeObserver as ResizeObserver).disconnect()
        }
    }
}
